import { memo } from "react";
import { formatTimeFromUtc } from "utils/formatters";
import { RegionInfoItem } from "./RegionInfoItem";

type Props = {
  lastExamDate: string;
  videoExamsQuantity: string | number;
  classNames?: string;
  title: string;
  
};
export const RegionInfoItems = memo(
  ({
    lastExamDate,
    videoExamsQuantity,
    title,
    classNames

  }: Props) => {
    return (
      <div className={`flex`}>
        <div className="space-y-4">
          <RegionInfoItem title={title} className={`${classNames} `}>
            <strong className="text-m">
              {formatTimeFromUtc(lastExamDate) || "--"}
            </strong>
          </RegionInfoItem>
        </div>
        <div className="space-y-4">
          <RegionInfoItem title="Number of exams" className={`${classNames} ml-[8px]`}>
            <strong className="text-m">{videoExamsQuantity}</strong>
          </RegionInfoItem>
        </div>
      </div>
    );
  }
);
